import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit, inject, signal } from '@angular/core';
import { Subject, filter, takeUntil } from 'rxjs';
import { NewFeatureDotService } from '../../../services/new-feature-dot.service';

@Component({
  selector: 'app-new-feature-dot',
  templateUrl: './new-feature-dot.component.html',
  styleUrls: ['./new-feature-dot.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class NewFeatureDotComponent implements OnInit, OnDestroy {
  private newFeatureDotService = inject(NewFeatureDotService);
  @Input() featureName: string;
  @Input() featureNames: string[];
  @Input() position = 'top-right';
  destroyed$ = new Subject<void>();
  showDot = signal(false);

  ngOnInit() {
    this.calcShowDot();
    this.newFeatureDotService.onUpdates$
      .pipe(takeUntil(this.destroyed$), filter(Boolean))
      .subscribe(() => this.calcShowDot());
  }

  calcShowDot() {
    if (this.featureName) {
      this.showDot.set(this.newFeatureDotService.showFeatureAsNew(this.featureName));
    } else {
      if (this.featureNames.length) {
        this.showDot.set(this.featureNames.every(feature => this.newFeatureDotService.showFeatureAsNew(feature)));
      } else {
        this.showDot.set(false);
      }
    }
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
